import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { pathname } from '../../../../utils';
import { useHistory } from 'react-router';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import LoadingButton from '../../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  dialogAction: { alignSelf: 'center' },
  button: {
    minWidth: 175,
  },
}));

export default function FastExposure({ loading, closeDialog, storeName }) {
  const classes = useStyles();
  const history = useHistory();

  const content = (
    <>
      <Typography gutterBottom>
        Our team has reviewed the submitted Lines and has decided not to offer{' '}
        {storeName} a Growth Plan until the following requirements are met:
        <li>
          All Lines for a given product should start and end in succession, the
          marker of a periodical supply chain.
        </li>
        <li>All Lines must include a minimum of 2 funds delivery stages.</li>
        <li>
          Highly recommended: Avoid going out of stock by building Lines for a
          given product with partial overlap. One Line should start before the
          previous has ended, to avoid going out of stock.
        </li>
      </Typography>
      <Typography>
        We have returned your Lines to ‘Draft’ to give you an opportunity to
        revise and resubmit. If you believe we made a mistake, please resubmit
        and include any supporting information that can help our team make a
        decision.
      </Typography>
    </>
  );

  const actions = (
    <LoadingButton
      className={classes.button}
      loading={loading}
      onClick={() => history.push(pathname.lines.url)}
    >
      <b>Go to Lines</b>
    </LoadingButton>
  );

  return (
    <>
      <DialogContent className={classes.root}>{content}</DialogContent>
      <DialogActions className={classes.dialogAction}>{actions}</DialogActions>
    </>
  );
}
